import React, { Component } from 'react';
import { connect } from 'react-redux';
import { detailsDispatcher } from '../../../../../redux/related-product-builder-popup/related-product.dispatchers';
import ProductInformation from '../product-information';
import ChooseColor from '../choose-color';
import { QuantityBlockSingle } from '../quantity-block-single';
import { QuantityBlockMultiple } from '../quantity-block-multiple';
import { detailsSelector } from '../../../../../redux/related-product-builder-popup/related-product.selectors';
import SwitchButton from '../../../../routes/client/product/components/details/components/switch-button/switch-button';
import classes from './details.scss';
import Footer from './components/footer';
class DetailsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sizesDialogOpened: false
    };
    this.props.init();
  }
  render() {
    const {
      product: {
        colored,
        variants,
        sizeDependentPrice,
        hasSize
      },
      popupMode,
      showColorSection,
      variant,
      sizes,
      sizeIndex,
      onVariantChange,
      onSizeIndexChange,
      isFullDesignProduct,
      addAssociatedProduct,
      isQuantityAmountValid,
      onCloseHandler
    } = this.props;
    const chooseSize = number => /*#__PURE__*/React.createElement("div", {
      className: classes.block
    }, /*#__PURE__*/React.createElement("h5", {
      className: classes.blockTitle
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.number
    }, number), "Choose size"), /*#__PURE__*/React.createElement("div", {
      className: classes.fullRow
    }, sizes.options && sizes.options.map((v, i) => /*#__PURE__*/React.createElement(SwitchButton, {
      key: i,
      "data-size": i,
      onClick: () => onSizeIndexChange(i),
      isActive: sizeIndex === i
    }, v))));
    const chooseVariant = number => /*#__PURE__*/React.createElement("div", {
      className: classes.block
    }, /*#__PURE__*/React.createElement("h5", {
      className: classes.blockTitle
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.number
    }, number), "Choose type"), /*#__PURE__*/React.createElement("div", null, variants.map((v, i) => /*#__PURE__*/React.createElement(SwitchButton, {
      key: i,
      onClick: () => onVariantChange(i),
      isActive: (variant === null || variant === void 0 ? void 0 : variant.name) === v.name
    }, v.name))));
    const sizeQuantityBlock = number => this.props.splitOrderMode ? /*#__PURE__*/React.createElement(QuantityBlockMultiple, {
      number: number
    }) : /*#__PURE__*/React.createElement(QuantityBlockSingle, {
      number: number
    });
    let blockCounter = 0;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.details
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.block
    }, /*#__PURE__*/React.createElement(ProductInformation, null)), sizeDependentPrice ? /*#__PURE__*/React.createElement("div", null, !colored && !isFullDesignProduct && chooseVariant(blockCounter += 1), !!hasSize && chooseSize(blockCounter += 1), !!colored && showColorSection && /*#__PURE__*/React.createElement(ChooseColor, {
      number: blockCounter += 1
    }), sizeQuantityBlock(blockCounter += 1)) : /*#__PURE__*/React.createElement("div", null, !isFullDesignProduct && (colored ? showColorSection && /*#__PURE__*/React.createElement(ChooseColor, {
      number: blockCounter += 1
    }) : chooseVariant(blockCounter += 1)), sizeQuantityBlock(blockCounter += 1)), /*#__PURE__*/React.createElement(Footer, {
      addAssociatedProduct: addAssociatedProduct,
      popupMode: popupMode,
      onClose: onCloseHandler,
      isQuantityAmountValid: isQuantityAmountValid
    }));
  }
}
export const Details = connect(detailsSelector, detailsDispatcher)(DetailsComponent);